import { Component, EventEmitter, input, Input, Output } from '@angular/core';

@Component({
  selector: 'app-header-nav-widget',
  templateUrl: './header-nav-widget.component.html',
  styleUrl: './header-nav-widget.component.scss'
})
export class HeaderNavWidgetComponent {

  @Input() text: string;
  @Input() description: string;
  @Input() descriptionColor: string = 'text-gray-800';

  @Input() icon: string = 'ki-information-4';
  @Input() iconColor: string = 'dark';

  @Input() historyLabel: string = 'Vissza';
  @Input() historyLink = [];
  @Input() historyParams = {};
  
  @Input() action: string = 'none';
  @Input() actionTrigger: string = undefined; // ha popup-ot kell triggerelni

  @Input() switchValue: number = 0;

  @Output() switchChange: EventEmitter<number> = new EventEmitter();
  // akkor használjuk ha valaki az action gombot megnyomta (jelenleg csak chat esetén)
  @Output() actionPressed: EventEmitter<void> = new EventEmitter();

  onSwitchCallback(value: number): void {
    this.switchChange.emit(value);
  }

  onActionPressed(): void {
    this.actionPressed.emit();
  }

}
